module.exports = __webpack_public_path__ + "static/media/ZM.789d0535.png";